module.exports = __webpack_public_path__ + "assets/raleigh-north-carolina-tech-companies-2.21624465.png";